import { faArrowAltCircleLeft } from "@fortawesome/free-regular-svg-icons";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useBackNavigation } from "../../../hooks/BackNavigation";
import DataTable from "../../common/components/DataTable";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../template/store";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUnpaidInvoice } from "../dashboard/actions/instruction";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AESDecrypt, AESEncrypt } from "../../../encrypt-util";
import useDataCountry from "../../../hooks/useDataCountry";
import InfoDiv from "../../../components/common/InfoDiv";
import AttachmentsPaymentTable from "./AttachmentPaymentsTable";
import { getUnprefixedPathname } from "../../../helpers/utils";
import useBlCountry from "../../../hooks/useBlCountry";
import { useLinerConfig } from "../../../hooks/useLinerConfig";
import { useLoading } from "../../../middleware/loadingMiddleware";

function useImex():"import"|"export"{
  const grpCountries = useSelector((state:RootState) => state.userProfile.countryList)
  const dataCountry = useDataCountry()
  const oblForm = useSelector((state: RootState) => state.oblDetails.oblForm);
  const isImport = [...(grpCountries??[]), {countryCode:dataCountry}]?.filter((x:any)=>x.countryCode)
                        .map((x:any)=>x.countryCode)
                        .some((countryCode:string) => oblForm.pod?.substring(0,2) == countryCode || oblForm.fpod?.substring(0,2) == countryCode)
  
  return isImport?"import":"export";
}


export default function InvoiceUnpaid() {
  const { t } = useTranslation()
  const onBack = useBackNavigation()
  const {encrypt} = useParams()

  const decrypted = AESDecrypt(encrypt ?? '');
  const n = Number(decrypted);
  const instructionIdNum = Number.isNaN(n) ? 804 : n;
  const instructionIdString = String(instructionIdNum);


  const data = useSelector((state: RootState) => state.invoiceUnpaid.data)
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const location = useLocation()
  const unpaidInvoiceLoading = useLoading(['instruction/getUnpaidData'])
  
  const rbac = useSelector((state: RootState) => state.userProfile.rbacDetails)
  const datacountry = useDataCountry()
  const imex = useImex()//oblForm.pod?.substring(0, 2) == dataCountry || oblForm.fpod?.substring(0, 2) == dataCountry ? "import" : "export"
  const [blCountry, _] = useBlCountry("new", imex, null)
        
  const blid: any = useSelector(
    (state: RootState) => state.documentHistory.data?.[0]?.blId
  );

    

  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );

  const selectedLinerId = useSelector(
    (state: RootState) => state.navbarTop.linerId
  );
  

  const unreleased = data.find((item) => !item.ccy || item.ccy === '')
  const paymentData = useSelector((state:RootState)=>state.invoiceUnpaid.paymentData)
  const unreleasedOnly = data.filter((item) => item.ccy && item.ccy !== '').length == 0

  const linerId =
    profileDetails.partnerType === 'liner'
      ? profileDetails.partnerId
      : selectedLinerId;

    const linerConfig=useLinerConfig(blCountry,`${linerId}`,instructionIdNum ?? 804);

  
  useEffect(() => {
    if (blid && datacountry && linerId && 
      (linerConfig.crrPopAttStop == 'Y' || linerConfig.crrUnpaidHardStop == 'Y'
    || linerConfig.crrUnpaidSoftStop == 'Y')){
      dispatch(getUnpaidInvoice({crrPopAttStop: linerConfig?.crrPopAttStop, blid, country: datacountry, linerId: linerId,location:null }))
    }
  }, [blid, linerId, linerConfig?.crrPopAttStop, linerConfig?.crrUnpaidHardStop, linerConfig?.crrUnpaidSoftStop, datacountry])
  
  useEffect(() => {
    if (data.length == 0 && paymentData.length == 0 && !unpaidInvoiceLoading && blCountry) {

      // navigate(location.pathname.replace(`/${encrypt}/unpaid`, `instruction/${AESEncrypt(instructionIdString)}`))

       const safeEncrypt = encodeURIComponent(encrypt || '');
       navigate(
      location.pathname.replace(
        `/${safeEncrypt}/unpaid`,
        `/instruction/${AESEncrypt(instructionIdString)}`
      )
    );
      
    }

  }, [data, paymentData, unpaidInvoiceLoading, blCountry])

  return <Card style={{ minHeight: '100%' }}>
    <Card.Header className='d-flex align-items-center border-bottom sticky-top bg-white'>
      <FontAwesomeIcon
        icon={faArrowAltCircleLeft}
        className='text-warning cursor-pointer fa-lg mb-1 me-1'
        onClick={onBack}
      />

      <h2 className='fs-0 text-primary mb-1'>
        {t('resource_2:unpaid_invoice')}
      </h2>
    </Card.Header>
    <Card.Body>
      <div className='container'>
        <div className='row'>

       {/*  {(data?.length > 0 || paymentData?.length > 0) && <ul className='mb-0 fs--1' style={{ paddingLeft: '30px',color: '#f5822a' }}>
            {t('resource_7:actionRequiredCrrMessage')
              .split('\n')
              .map((v: any) => (
                <li>{v}</li>
              ))}
          </ul>
        } */}
       
        

        {linerConfig.crrPopAttStop == 'Y' && paymentData?.length > 0 && <ul className='mb-2 fs--1' style={{ paddingLeft: '30px',color: '#f5822a' }}>
            {t('resource_7:mandatePOPMessage')
              .split('\n')
              .map((v: any) => (
                <li>{v}</li>
              ))}
          </ul>
        }
        {linerConfig.crrPopAttStop == 'Y' && paymentData.length > 0 && <AttachmentsPaymentTable/>}

         
          {data.length <= 0 ? "" :linerConfig.crrUnpaidHardStop == 'Y'  ?
          <ul className='mb-2 fs--1' style={{ paddingLeft: '30px',color: '#f5822a' }}>
            {t('resource_7:unpaidInvoiceMessage')
              .split('\n')
              .map((v: any) => (
                <li>{v}</li>
              ))}
          </ul> :
        <span className='mb-2 fs--1'
          style={{ color: '#f5822a' }}
        >
       {t('resource_7:unpaidInvoiceSoftMessage')} </span>
       
       }

          {unreleased &&
            <span className='mb-2 fs--1'
              style={{ color: '#2c7be5' }}
            >{t('resource_7:unreleasedInvoiceMessage')}</span>
          }
        </div>
        {
          // the initial state array has length 1 since otherwise the screen will
          // automatically redirect to CRR
          // so we need to check the keys of the obj to make sure its API response
          // and not the placeholder 
          data?.length > 0 &&
          Object.keys(data[0]).length > 0 &&
          <DataTable
            data={data}
            gridName="INVOICE_UNPAID"
            columns={unpaidColumns}
            sortable={false}
            searchable={false}
            showColumnFilter={false}
            selection={false}
            perPage={10}
            pagination={false}
            showExport={false}
            uniqueFilterKey='invoiceunpaid'
            autoHeight={true}
            staticHiddenCols={['invid']}
          />}
        <div className='d-flex align-items-center mt-4'
          style={{ justifyContent: 'space-evenly' }}>

          {data?.length > 0 && <div className='d-flex align-items-center'>
            <InfoDiv title={t('resource_message:popPayInfo')}>
              <Button variant='falcon-primary' size='sm'
                onClick={() => { navigate(`${location.pathname}/payment`) }}
                disabled={data?.length == 0 || unreleasedOnly}
              >{t('resource_1:proceedpay')}
              </Button>
            </InfoDiv>

          </div>}
          {(linerConfig.crrUnpaidHardStop != 'Y' || (( data?.length == 0 ) && ( paymentData?.length == 0 ))) &&
            <div className='d-flex align-items-center'>
              <InfoDiv title={t('resource_message:popIgnoreInfo')}>
                <Button variant='falcon-primary' size='sm'
                  // onClick={() => {
                  //   navigate(location.pathname.replace('unpaid', `instruction/${AESEncrypt('804')}`))
                  // }}
                  // onClick={() => {
                  //   navigate(location.pathname.replace(`/${encrypt}/unpaid`, `/instruction/${AESEncrypt(instructionIdString)}`))
                  // }}
                  onClick={() => {
                    const safeEncrypt = encodeURIComponent(encrypt || '');

                    const target = location.pathname.replace(
                      `/${safeEncrypt}/unpaid`,
                      `/instruction/${AESEncrypt(instructionIdString)}`
                    );

                    navigate(target);
                  }}
                  >{t('resource_1:proceedrelease')}
                </Button>
              </InfoDiv>
            </div>
          }

        </div>
      </div>
    </Card.Body>
  </Card>
}

const unpaidColumns = [
  {
    accessor: 'invno',
    Header: 'Invoice Number',
    width: 200,
    maxWidth: 150
  },
  {
    accessor: 'ccy',
    Header: 'CCY',
    width: 120,
    maxWidth: 100
  },
  {
    accessor: 'amount',
    Header: 'Amount',
    width: 150,
    maxWidth: 100
  },
  {
    accessor: 'invtype',
    Header: 'Invoice Type',
    width: 200,
    maxWidth: 150
  },
];
